import * as React from 'react'

const PropTypes = require('prop-types')
const classnames = require('classnames')

function sortRows(rows, column, sortASC) {
  return rows.sort((a, b) => {
    const multiplier = sortASC ? 1 : -1
    const aValue = column.getCellRawValue ? column.getCellRawValue(a) : column.getCellValue(a)
    const bValue = column.getCellRawValue ? column.getCellRawValue(b) : column.getCellValue(b)
    if (aValue < bValue) {
      return -1 * multiplier
    }
    if (aValue > bValue) {
      return 1 * multiplier
    }
    return 0
  })
}

class Table extends React.Component {
  constructor(props) {
    super(props)

    const { defaultSortBy, defaultSortASC, columns } = props
    let { rows } = props
    if (defaultSortBy) {
      const column = columns.find(elt => elt.name === defaultSortBy)
      if (column) {
        rows = sortRows(rows, column, defaultSortASC)
      }
    }

    this.state = {
      sortBy: defaultSortBy,
      sortASC: !!defaultSortASC,
      rows,
    }
  }

  render() {
    const {
      columns,
      getRowKey,
      onRowClick,
      getSubRows,
      getSubRowKey,
      tableClass,
      isNarrow,
      isStriped,
      isHoverable,
      isFullWidth,
    } = this.props

    const { sortBy, sortASC, rows } = this.state

    return (
      <div
        style={{
          overflowX: 'scroll',
        }}
      >
        <table
          className={classnames(
            'table',
            {
              'is-narrow': isNarrow,
              'is-striped': isStriped,
              'is-hoverable': isHoverable,
              'is-fullwidth': isFullWidth,
            },
            tableClass
          )}
        >
          <thead>
            <tr>
              {columns.map(column => (
                <th
                  key={column.name}
                  style={{ verticalAlign: 'middle' }}
                  className={classnames('has-padding-zero', {
                    'has-text-right': column.isTextRight,
                    'has-text-centered': column.isTextCentered,
                  })}
                >
                  {
                    <button
                      className={classnames('button is-white is-small is-size-8-mobile has-padding-zero', {
                        'has-text-weight-bold': sortBy === column.name,
                      })}
                      style={
                        column.isSortable
                          ? {
                              height: 'auto',
                            }
                          : {
                              height: 'auto',
                              pointerEvents: 'none',
                            }
                      }
                      type="button"
                      onClick={() => {
                        const newSortASC = sortBy === column.name ? !sortASC : sortASC
                        this.setState({
                          sortBy: column.name,
                          sortASC: newSortASC,
                          rows: sortRows(rows, column, newSortASC),
                        })
                      }}
                    >
                      <div key="column-display-1" dangerouslySetInnerHTML={{ __html: column.display }} />
                      {sortBy === column.name && (
                        <span
                          key="column-display-2"
                          className={classnames('icon is-small', 'has-margin-left-small', 'has-text-primary')}
                        >
                          <i
                            className={classnames('fas', {
                              'fa-arrow-down': sortASC,
                              'fa-arrow-up': !sortASC,
                            })}
                          />
                        </span>
                      )}
                    </button>
                  }
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(row => [
              <tr
                key={getRowKey(row)}
                onClick={() => onRowClick && onRowClick(row)}
                style={{
                  ...(onRowClick ? { cursor: 'pointer' } : {}),
                }}
              >
                {columns.map(column => (
                  <td
                    key={`${getRowKey(row)}-${column.name}-row-value`}
                    className={classnames({
                      'has-text-centered': column.isTextCentered,
                      'has-text-weight-bold': column.isBold,
                    })}
                    style={{
                      verticalAlign: 'middle',
                    }}
                  >
                    {column.getCellValue && column.getCellValue(row)}
                  </td>
                ))}
              </tr>,
              (getSubRows ? getSubRows(row) : []).map((subRow, subRowIdx) => (
                <tr key={getSubRowKey(row, subRow)} className="animated fadeIn faster">
                  {columns.map(column => (
                    <td
                      key={`${getSubRowKey(row, subRow)}-${column.name}-sub-row-value`}
                      className={classnames({
                        'has-text-right': column.isSubRowTextRight,
                        'has-text-centered': column.isSubRowTextCentered,
                        'has-text-weight-bold': column.isSubRowBold,
                      })}
                    >
                      {column.getCellSubRowValue && column.getCellSubRowValue(row, subRow, subRowIdx)}
                    </td>
                  ))}
                </tr>
              )),
            ])}
          </tbody>
        </table>
      </div>
    )
  }
}

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  getRowKey: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  getSubRows: PropTypes.func,
  getSubRowKey: PropTypes.func,
  isNarrow: PropTypes.bool,
  isStriped: PropTypes.bool,
  isHoverable: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  tableClass: PropTypes.string,
  defaultSortBy: PropTypes.string,
  defaultSortASC: PropTypes.bool,
}

Table.defaultProps = {
  onRowClick: null,
  getSubRows: null,
  getSubRowKey: null,
  isNarrow: true,
  isStriped: true,
  isHoverable: true,
  isFullWidth: false,
  tableClass: undefined,
  defaultSortBy: undefined,
  defaultSortASC: true,
}

module.exports = Table
